import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

const WhatsAppFloat = () => {
  // Instagram Direct Message link
  const instagramLink = "https://ig.me/m/adastrarestaurant";

  return (
    <a
      href={instagramLink}
      target="_blank"
      rel="noopener noreferrer"
      className="instagram-float group"
      aria-label="Chat en Instagram"
    >
      <FontAwesomeIcon 
        icon={faInstagram} 
        className="w-7 h-7 text-white group-hover:scale-110 transition-transform duration-300" 
      />
    </a>
  );
};

export default WhatsAppFloat;